// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"AtendimentoRestrito_containerPrincipal__ZRJuO","divConvenios":"AtendimentoRestrito_divConvenios__42eeX"};